// extracted by mini-css-extract-plugin
export default {"btnDetail":"CoursesItem_btnDetail__SivEY","iconActive":"CoursesItem_iconActive__o-3w0","icon":"CoursesItem_icon__DDVEo","arrowIconActive":"CoursesItem_arrowIconActive__uuist"};